(() => {
  function connect(section) {
    if (section.dataset.connected) return;
    section.dataset.connected = 'true';
    const widget = section.querySelector('#judgeme_product_reviews');
    const archive = section.nextElementSibling;
    // Keep the archive visible until Judge.me has rendered usable live content.
    const ready = () => {
      const content = widget.querySelector('.jdgm-rev-widg, [data-testid="review-widget"], [data-testid="write-review-button"]');
      if (!content || !content.getClientRects().length) return false;
      if (archive?.matches('rettrose-review-grid')) archive.hidden = true;
      const empty = section.querySelector('[data-rr-live-empty]');
      if (empty) {
        const count = widget.querySelector('[data-number-of-reviews]')?.getAttribute('data-number-of-reviews');
        if (widget.querySelector('.jdgm-rev')) empty.hidden = true;
        else if (count === '0') empty.hidden = false;
      }
      section.querySelector('[data-rr-live-help]').hidden = true;
      return true;
    };
    const observer = new MutationObserver(ready);
    observer.observe(widget, {childList:true, subtree:true, attributes:true, attributeFilter:['class','style','hidden']});
    ready();
    setTimeout(() => {
      if (!section.isConnected) { observer.disconnect(); return; }
      if (!ready()) section.querySelector('[data-rr-live-help]').hidden = false;
    }, 15000);
  }
  function init() { document.querySelectorAll('[data-rr-live-reviews]').forEach(connect); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
